<template>
    <div id='page_Container'>
        <div id="main-container" class='main-container'>
            <div id="apply-after-sales">
                <div class="product-info">
                    <div class="pro-img">
                        <img :src="productInfo.productImg" alt="">
                    </div>
                    <div class="pro-info">
                        <div class="pro-title">{{productInfo.productName}}</div>
                        <div class="pro-sku">{{productInfo.specificationValue}}</div>
                    </div>
                </div>
                <van-cell-group>
                    <van-cell :title="`${afterSalesTypeDesc}数量`">
                        <!-- :title="`${afterSalesTypeDesc}数量`" :value="`${applyDetails.quantity}件`" -->
                        <van-stepper v-model="applyDetails.quantity" :max="applyDetails.max"/>

                    </van-cell>
                    <van-cell :title="`${afterSalesTypeDesc}日期`" is-link :value="applyDetails.appointmentTime || '请选择'" @click="datetimePickerShow=true"/>
                    <van-cell :title="`${afterSalesTypeDesc}时间`" is-link :value="applyDetails.appointmentTimeQuantum || '请选择'" @click="pickerShow=true"/>
                    <van-field :label="`${afterSalesTypeDesc}地址`" v-model="applyDetails.appointmentAddress" :placeholder="`请输入${afterSalesTypeDesc}地址`" type="textarea" autosize input-align="right" rows="1"/>
                    <van-field label="联系人" v-model="applyDetails.accountName" placeholder="请输入联系人" input-align="right"/>
                    <van-field label="联系电话" v-model="applyDetails.accountPhone" placeholder="请输入联系电话" input-align="right"/>
                    <van-field
                        v-model="applyDetails.remark"
                        label="备注"
                        type="textarea"
                        placeholder="请输入备注"
                        rows="1"
                        input-align="right"
                        autosize
                    />
                    <div v-if="afterSalesType !== 'install'">
                        <van-cell title="照片" :border="false" value="最多上传3张图片"/>
                        <div style="padding: 0 15px 15px">
                            <es-photo-album
                                :data-source="photoDate.dataSource"
                                :is-disabled="photoDate.isDisabled"
                                :max-count="photoDate.maxCount"
                                :other-data="photoDate.otherData"
                                :origin="photoDate.origin"
                                :save="photoDate.save"
                                :size-type="photoDate.sizeType"
                                :before-action="photoDate.beforeAction"
                            />
                        </div>
                    </div>
                </van-cell-group>
                <div class="confirm-btn">
                    <van-button size="large" type="primary" round @click="handleSubmit" :disabled="btnDisabled">确定</van-button>
                </div>
                <van-popup v-model="datetimePickerShow" position="bottom">
                    <van-datetime-picker
                        v-model="datetimePickerObj.currentDate"
                        type="date"
                        :min-date="datetimePickerObj.minDate"
                        @cancel="datetimePickerShow=false"
                        @confirm="datetimePickerConfirm"
                    />
                </van-popup>
                <van-popup v-model="pickerShow" position="bottom">
                    <van-picker
                        v-model="afterSalesTime"
                        :columns="pickerColumns"
                        :show-toolbar="true"
                        @cancel="pickerShow=false"
                        @confirm="pickerShowConfirm"
                    />
                </van-popup>

            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
// import moment from 'moment';
import { validatePhone, toastLoading, clearToastLoading } from '@/utils/base/utils';
export default {
    data() {
        return {
            btnDisabled: false,
            datetimePickerShow: false,
            pickerShow: false,
            afterSalesTime: '',
            productInfo: {
                productName: '',
                productImg: '',
                specificationValue: ''
            },
            applyDetails: {
                quantity: 1,
                max: 1,
                appointmentTime: '',
                appointmentTimeQuantum: '',
                appointmentAddress: '',
                accountName: '',
                accountPhone: '',
                remark: ''
            },
            photoDate: {
                dataSource: [],
                isDisabled: false,
                maxCount: 3,
                otherData: {},
                origin: ['camera', 'album'],
                save: true,
                sizeType: 'default'
            },
            datetimePickerObj: {
                minDate: this.getMinDate(),
                currentDate: new Date()
            },
            // pickerColumns: ['上午', '下午', '全天'],
            afterSalesType: this.$route.query.type,
            afterSalesTypeDesc: '安装'
        };
    },
    esvShow() {
        this.afterSalesTypeDesc = this.afterSalesType === 'install' ? '安装' : '维修';
        document.title = '申请' + this.afterSalesTypeDesc;
        const { area, address, accountNickName, accountMobileNumber, memberOrderItemList } = this.orderDetails;
        const { orderCode, quantity, productName, productImg, specificationValue } = memberOrderItemList[0];
        this.applyDetails = {
            orderCode,
            max: quantity,
            quantity: 1,
            appointmentTime: '',
            appointmentTimeQuantum: '',
            appointmentAddress: area + address,
            accountName: accountNickName,
            accountPhone: accountMobileNumber,
            remark: '',
            appointmentChannel: 'WECHAT',
            appointmentType: this.afterSalesType === 'install' ? '2' : '3'
        };
        this.productInfo = {
            productName,
            productImg,
            specificationValue
        };
    },
    methods: {
        ...mapMutations(['changeChoiceGoodsItem']),
        applyAppointmentRecord(params) {
            this.$doRequest(
                {
                    url: '/appoint/applyAppointmentRecord',
                    params: { ...params, merchantInfo: JSON.stringify(this.merchantInfoSwitch) },
                    before: () => {
                        this.loading = toastLoading();
                    },
                    complete: () => {
                        clearToastLoading(this.loading);
                        this.btnDisabled = false;
                    }
                },
                (data) => {
                    this.changeChoiceGoodsItem({ statusName: 'serviceFlag', status: 1 });
                    // let statusName = this.afterSalesType === 'install' ? 'setupStatus' : 'repairedStatus';
                    // this.changeChoiceGoodsItem({ statusName, status: 10 });
                    this.esvReloadPage({ name: 'OPAfterSalesDetails', query: { type: this.afterSalesType, appointId: data.result.appointId } });
                }
            );
        },
        getMinDate() {
            // let curDate = new Date();
            // let curStartDate = new Date(curDate.toLocaleDateString() + ' 00:00');
            // let endDate = new Date(curDate.toLocaleDateString() + ' 16:00');
            // if (curDate.getTime() < endDate.getTime()) {
            //     return new Date(curStartDate.getTime() + 1000 * 60 * 60 * 24);
            // } else {
            //     return new Date(curStartDate.getTime() + 1000 * 60 * 60 * 24 * 2);
            // }
            // 禁用当天以前的日期
            return new Date();
        },
        datetimePickerConfirm(value) {
            this.applyDetails.appointmentTime = this.$moment(value).format('YYYY-MM-DD');
            // this.pickerShow = true;
            this.datetimePickerShow = false;
        },
        pickerShowConfirm(value) {
            this.applyDetails.appointmentTimeQuantum = value;
            this.pickerShow = false;
        },
        dealData() {
            let appointmentTimeQuantum = '';
            let returnObj = {};
            // 转义
            switch (this.applyDetails.appointmentTimeQuantum) {
            case '上午':
                appointmentTimeQuantum = 'SW';
                break;
            case '下午':
                appointmentTimeQuantum = 'XW';
                break;
            case '全天':
                appointmentTimeQuantum = 'QT';
                break;

            default:
                break;
            }
            returnObj = {
                appointmentTimeQuantum
            };
            // 维修图片数据处理
            if (this.afterSalesType === 'repair') {
                const { dataSource } = this.photoDate;
                const imageArr = [];
                dataSource.forEach(ele => {
                    if (ele.photoUrl) {
                        imageArr.push(ele.photoUrl);
                    }
                });
                returnObj.images = imageArr.join(',');
            }

            return returnObj;
        },
        handleSubmit() {
            console.log(this.photoDate);
            const {
                appointmentTime,
                appointmentTimeQuantum,
                appointmentAddress,
                accountName,
                accountPhone
            } = this.applyDetails;
            // 表单验证
            if (!appointmentTime) {
                this.$toast(`请选择${this.afterSalesTypeDesc}日期`);
                return false;
            } else if (!appointmentTimeQuantum) {
                this.$toast(`请选择${this.afterSalesTypeDesc}时间`);
                return false;
            } else if (!appointmentAddress) {
                this.$toast(`请选择${this.afterSalesTypeDesc}地址`);
                return false;
            } else if (!accountName) {
                this.$toast('联系人不能为空');
                return false;
            } else if (!validatePhone(accountPhone)) {
                this.$toast('联系电话格式不正确, 电话号码区号需要用-隔开');
                return false;
            }
            this.btnDisabled = true;
            const changedData = this.dealData();
            this.applyAppointmentRecord({ ...this.applyDetails, ...changedData, orderItemId: this.orderDetails.memberOrderItemList[0].id });
        }
    },
    watch: {
        pickerColumns: {
            handler(cur) {
                if (cur.indexOf(this.afterSalesTime) === -1) {
                    this.afterSalesTime = cur[0];
                    this.applyDetails.appointmentTimeQuantum = '';
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapState({ orderDetails: state => state.order.orderDetails,
            choiceGoodsItemIndex: state => state.order.choiceGoodsItemIndex }),
        ...mapGetters([
            'merchantInfoSwitch'
        ]),
        pickerColumns() {
            const { currentDate } = this.datetimePickerObj;
            let pickerColumns = [];
            const curDay = this.$moment();
            const selectDay = this.$moment(currentDate);
            if (curDay.dayOfYear() === selectDay.dayOfYear() && curDay.hour() > 11) {
                pickerColumns = ['下午', '全天'];
            } else {
                pickerColumns = ['上午', '下午', '全天'];
            }

            return pickerColumns;
        }
    }
};
</script>

<style lang="scss">
    #apply-after-sales{
        overflow: auto;
        height: 100%;
        .product-info {
            padding: 12px;
            margin-bottom: 8px;
            background-color: #fff;
            display: flex;
            .pro- {
                &img {
                    width: 80px;
                    height: 80px;
                    flex: none;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                &info {
                    padding-left: 12px;
                    >div {
                        height: 40px;
                        line-height: 20px;
                        @include textoverflow
                    }
                }
                &title {

                }
                &sku {
                    color: #999;
                }
            }
        }
        .confirm-btn {
            margin: 30px 24px 0;
        }
    }
</style>
